import { isNaN, isNil } from 'lodash';
import { User } from '../@types/user';
import { Loja } from '../@types/emp';
import { ArquivoSessionStorage } from './modelos';
import { FarmaError } from 'src/integracoes/modelos/erros';
import { firebaseStorage } from 'src/integracoes/servicos/firebase/storage';
import { BRAND_PRIMARY_COLOR, tempoIntervaloEmail } from 'src/constants';
import { portalName } from 'src/config';

export const convertArrayToObject = (array: any[], key: string, key2 = ''): any => {
  const initialValue = {};
  const keyItem = key2 === '' ? key : key2;
  return array.reduce((obj, item) => {
    return {
      ...obj,
      [item[key]]: item[keyItem]
    };
  }, initialValue);
};
export const filterUsersEmail = (allUsers: User[]): any => {
  const arrayUsers = allUsers.map(({ email }) => {
    return {
      email: email
    };
  });
  return convertArrayToObject(arrayUsers, 'email');
};

type GetNameLoja = {
  lojas: Loja[];
  idLoja: string;
};

export const getNameLoja = ({ lojas, idLoja }: GetNameLoja): string => {
  function searchLojas(arrLoja: Loja): any {
    return arrLoja.id === idLoja;
  }
  const theLoja = lojas.find(searchLojas);
  if (typeof theLoja?.loja !== 'undefined') {
    return theLoja.loja;
  }
  return '';
};

export const getTimeToStamp = (timestamp: any): any => {
  try {
    const date = new Date();
    date.setSeconds(timestamp); // specify value for SECONDS here
    return date.toISOString().substr(11, 8);
  } catch {
    return timestamp;
  }
};

export const filterDashById = (id: any, allDashs: any[]): any => {
  try {
    const filteredDash = allDashs
      .map(({ dashs }) => {
        return dashs
          .filter((dash: any) => dash.dashId === id)
          .map((dashFiltered: any) => {
            return {
              name: dashFiltered.name,
              dku: dashFiltered.dku
            };
          });
      })
      .filter((dash) => dash.some((v: any) => true))[0];
    return filteredDash[0];
  } catch {
    return {
      name: id,
      dku: 'vazio'
    };
  }
};

interface MenuItens {
  baseUrl: string;
  itens: any[];
  empId: string;
  subHeaderName: string;
  subHeaderIdName: string;
  subItemIdName: string;
  itemName: string;
  papeis: string[];
  subItemLojaIdName: string;
  title: string;
}

export const listMenuUrl = ({
  baseUrl,
  itens,
  empId,
  subHeaderName,
  subHeaderIdName,
  itemName,
  subItemIdName,
  subItemLojaIdName,
  papeis
}: MenuItens): { title: string; items: any[] }[] => {
  try {
    const itensList: { title: string; items: any[] }[] = [];

    // Percorre as categorias/paineis
    itens.map((item: any) => {
      const tempList = {
        title: item[subHeaderName], // O nome da categoria
        href: `${baseUrl}/${empId}/${item[subHeaderIdName]}`,
        allowedRoles: papeis,
        items: item[itemName].map((sub: any) => {
          return {
            title: sub.name, // Nome do painel
            entidadeNome: sub.entidadeNome,
            href:
              sub.entidadeTipo === 'loja'
                ? `${baseUrl}/empresas/${empId}/lojas/${sub[subItemLojaIdName]}/paineis/${sub[subItemIdName]}`
                : `${baseUrl}/empresas/${empId}/paineis/${sub[subItemIdName]}`,
            icon: sub.icon, // Ícone
            allowedRoles: papeis,
            svgIcon: true
          };
        })
      };

      // Adiciona a lista de itens/paineis na lista final
      itensList.push(tempList);
    });

    return itensList;
  } catch {
    return [];
  }
};

/* mascaras  dos inputs    */
// telefone
export const formatarNumeroTelefone = (value: string): string => {
  return value
    .replace(/\D/g, '') // Remove caracteres não numéricos
    .replace(/^(\d{2})(\d)/g, '($1) $2') // Coloca parênteses nos dois primeiros dígitos
    .replace(/(\d)(\d{4,4})$/, '$1-$2'); // Coloca o hífen antes dos últimos quatro ou cinco dígitos
};
export const handlePhoneChange = (event: any, handleChange: any): any => {
  const { value, name } = event.target;
  const formattedPhone = formatarNumeroTelefone(value);
  handleChange({
    target: {
      name,
      value: formattedPhone
    }
  });
};
// CNPJ
const formatarCnpj = (value: string): string => {
  return value
    .replace(/\D/g, '') // Remove caracteres não numéricos
    .replace(/^(\d{2})(\d)/, '$1.$2') // Coloca ponto após os primeiros dois dígitos
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3') // Coloca ponto após os próximos três dígitos
    .replace(/\.(\d{3})(\d)/, '.$1/$2') // Coloca a barra após os próximos três dígitos
    .replace(/(\d{4})(\d)/, '$1-$2'); // Coloca o hífen antes dos últimos dois dígitos
};
export const handleCnpjChange = (event: any, handleChange: any): any => {
  const { value, name } = event.target;
  const formattedPhone = formatarCnpj(value);
  handleChange({
    target: {
      name,
      value: formattedPhone
    }
  });
};
// CEP
export const formatarCep = (value: string): string => {
  return value
    .replace(/\D/g, '') // Remove caracteres não numéricos
    .replace(/^(\d{5})(\d)/, '$1-$2'); // Coloca o hífen após os primeiros cinco dígitos
};
export const handleCepChange = (event: any, handleChange: any): any => {
  const { value, name } = event.target;
  const formattedPhone = formatarCep(value);
  handleChange({
    target: {
      name,
      value: formattedPhone
    }
  });
};

// recebe um number, string, null, ou undefined e retorna convertido para number (se precisar)
export const converteParaNumero = (valor: any): number => {
  if (valor === null || valor === undefined || valor === '') {
    return 0;
  }
  if (typeof valor === 'number') {
    return valor;
  }
  if (typeof valor === 'string') {
    const numero = Number(valor.replace(',', '.'));
    // numero eh um number
    if (!isNaN(numero)) {
      return numero;
    }
  }
  return 0;
};

// recebe um number, string, null, ou undefined e retorna string com numero no padrao '0,00'
export const converteNumeroParaString = (
  valor: any,
  casasDecimais: number,
  grouping = false // se true coloca o . para separar as casas dos milhares ex:'1.000.000'
): string => {
  if (valor === null || valor === undefined || valor === '') {
    return '0';
  }
  if (typeof valor === 'number') {
    return valor.toLocaleString('pt-BR', {
      minimumFractionDigits: casasDecimais,
      maximumFractionDigits: casasDecimais,
      useGrouping: grouping
    });
  }
  if (typeof valor === 'string') {
    const numero = Number(valor.replace(',', '.'));
    // numero eh um number
    if (!isNaN(numero)) {
      return numero.toLocaleString('pt-BR', {
        minimumFractionDigits: casasDecimais,
        maximumFractionDigits: casasDecimais,
        useGrouping: grouping
      });
    }
  }
  return '0';
};

// recebe uma string e retorna um inteiro
export const converteParaInteiro = (valor: string): number => {
  return parseInt(valor || '0', 10);
};

// recebe um string, null, ou undefined e retorna string
export const ajustaNumeroComVirgula = (valor: any): string => {
  if (valor === null || valor === undefined || valor === '') {
    return '0';
  }
  if (typeof valor !== 'string') {
    valor = valor.toString();
  }
  if (valor.includes('.') || valor.includes(',')) {
    const numero = Number(valor.replace(',', '.'));
    // numero eh um number
    if (!isNaN(numero)) {
      return numero.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: false
      });
    }
  }
  return valor;
};

export const obtemUrlDeArquivoNaSessionStorage = async (nomeArquivo: string): Promise<string> => {
  // location é uma propriedade do objeto Window disponível em qualquer contexto da aplicação
  const hostAtual = location.host;
  // sessionStorage é uma propriedade do objeto Window disponível em qualquer contexto da aplicação
  const arquivoSessionStorageString = sessionStorage.getItem(nomeArquivo);
  const arquivoSessionStorage: ArquivoSessionStorage =
    arquivoSessionStorageString && JSON.parse(arquivoSessionStorageString);

  if (arquivoSessionStorage && arquivoSessionStorage.host === hostAtual) {
    return arquivoSessionStorage.url;
  } else {
    try {
      const url = await firebaseStorage.obtemUrlArquivoNoStorage(nomeArquivo);
      const novoArquivoSessionStorage: ArquivoSessionStorage = { host: hostAtual, url: url };
      sessionStorage.setItem(nomeArquivo, JSON.stringify(novoArquivoSessionStorage));
      return novoArquivoSessionStorage.url;
    } catch (e) {
      const erro = {
        nome: 'FIREBASE-ERRO-DESCONHECIDO',
        mensagem: 'Erro ao obter a URL de um arquivo serviço de armazenamento',
        causa: e
      };
      throw new FarmaError(erro);
    }
  }
};

// Formata dados inputs reportId, wrokspaceId, datasetId para os formato de dado esperado UUID
export const formatInputsUuIds = (value: string) => {
  const rawValue = value.replace(/-/g, '').slice(0, 32);
  const sections = [
    rawValue.slice(0, 8),
    rawValue.slice(8, 12),
    rawValue.slice(12, 16),
    rawValue.slice(16, 20),
    rawValue.slice(20, 32)
  ];
  return sections.filter((section) => section).join('-');
};

export const handleUuIdChange = (event: any, handleChange: any) => {
  const { value, name } = event.target;
  const rawValue = value.replace(/-/g, '');

  if (rawValue.length > 32) return;

  const newValueUuId = formatInputsUuIds(value);

  handleChange({
    target: {
      name,
      value: newValueUuId
    }
  });
};

export const verificaAtributos = (dados: any, atributos: string[]): boolean => {
  if (isNil(dados)) {
    return false;
  }
  for (var atr of atributos) {
    if (typeof dados[atr] === 'undefined' || dados[atr] === '') {
      return false;
    }
  }
  return true;
};

export const alterarCorImagemFundo = (classes: any, svgPath: string) => {
  // Carrega o SVG (imagem de fundo da tela de Login)
  fetch(svgPath)
    .then((response) => response.text())
    .then((svgText) => {
      // muda a cor de fundo do arquivo para a cor primaria
      const modifiedSvg = svgText.replace(
        /\.fil0\s*{fill:[^;}]+}/g,
        `.fil0 {fill:${BRAND_PRIMARY_COLOR}}`
      );
      const svgBlob = new Blob([modifiedSvg], { type: 'image/svg+xml' });
      const svgUrl = URL.createObjectURL(svgBlob);
      const rootElement: any = document.querySelector(`.${classes.root}`);
      if (rootElement) {
        rootElement.style.backgroundImage = `url(${svgUrl})`;
      }
    })
    .catch((e) => {
      throw new FarmaError(e);
    });
};

// compara os atributos passados entre dois objetos para validar se são igauais
export const comparaAtributos = (oldData: any, newData: any, atributos: string[]): boolean => {
  if (!oldData || !newData) return false;

  for (const atributo of atributos) {
    if (oldData[atributo] !== newData[atributo]) {
      return false; // Se qualquer campo for diferente, retorna false
    }
  }

  return true; // Se todos os campos forem iguais, retorna true
};

export const minutosRestantes = (data?: string | Date): number => {
  if (!data) return tempoIntervaloEmail;

  const dataCriacao = new Date(data);
  if (isNaN(dataCriacao.getTime())) return tempoIntervaloEmail;

  const agora = new Date();
  const diffMs = agora.getTime() - dataCriacao.getTime();
  const diffMin = Math.floor(diffMs / (60 * 1000));

  const restante = tempoIntervaloEmail - diffMin;

  return Math.max(0, Math.min(restante, tempoIntervaloEmail)); // garante que fique entre 0 e o tempoIntervaloEmail
};

interface NumeroEComplemento {
  numero: number | '';
  complemento: string;
}

export const extrairNumeroEComplemento = (
  numeroOriginal: string | undefined,
  complementoOriginal: string | undefined
): NumeroEComplemento => {
  if (!numeroOriginal) {
    return {
      numero: '',
      complemento: complementoOriginal ?? ''
    };
  }
  // extrai a parte numérica
  const numeroMatch = numeroOriginal.match(/\d+/)?.[0];
  const numero = numeroMatch ? Number(numeroMatch) : '';
  // extrai somente letras (A-Z ou a-z)
  const complementoExtra = numeroOriginal
    .replace(/[0-9]/g, '') // remove números
    .replace(/[^a-zA-Z]/g, '') // remove tudo que não seja letra
    .trim();
  // se complemeto original estiver vazio, usa o extra, senão mantém o original
  const complemento =
    complementoOriginal && complementoOriginal.trim() !== ''
      ? complementoOriginal.trim()
      : complementoExtra;
  return { numero, complemento };
};

export const textoCapitalizado = (text: string): string => {
  if (!text) return '';
  const preposicoes = ['de', 'da', 'do', 'das', 'dos', 'e', 'em', 'na', 'no', 'nas', 'nos', 'para'];
  return text
    .toLowerCase()
    .split(/\s+/)
    .map((word, index) => {
      if (index > 0 && preposicoes.includes(word)) return word;
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
};

export const somenteNumeros = (valor: string) =>
  valor.replace(/\D/g, '');

export const aplicarMascaraTelefone = (valor: string): string => {
  if (!valor) return '';

  let numeros = somenteNumeros(valor);

  // Sempre garante o DDI 55
  if (!numeros.startsWith('55')) {
    numeros = `55${numeros}`;
  }

  if (numeros.length <= 2) return `+${numeros}`;
  if (numeros.length <= 4)
    return numeros.replace(/^(\d{2})(\d{1,2})/, '+$1 ($2');

  if (numeros.length < 9)
    return numeros.replace(/^(\d{2})(\d{2})(\d+)/, '+$1 ($2) $3');

  if (numeros.length <= 12) {
    return numeros.replace(
      /^(\d{2})(\d{2})(\d{4})(\d{0,4})/,
      '+$1 ($2) $3-$4'
    );
  }

  return numeros.replace(
    /^(\d{2})(\d{2})(\d{5})(\d{4})/,
    '+$1 ($2) $3-$4'
  );
};

export const getToday = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getPreviousMonth = () => {
  const date = new Date();
  date.setMonth(date.getMonth() - 1); // retrocede 1 mês

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const boolOrEmpty = (v: any) => (v === true ? true : v === false ? false : '');

export const toStringBool = (value: boolean | undefined): string | undefined => {
  if (value === true) return 'true';
  if (value === false) return 'false';
  return undefined; // mantém vazio
};

export const parseBool = (value: string | undefined): boolean | undefined => {
  if (value === 'true') return true;
  if (value === 'false') return false;
  return undefined;
};

export const formatUUIDConnectorId = (value: string) => {
  const clean = value.replace(/[^a-fA-F0-9]/g, '').toLowerCase();

  return clean
    .slice(0, 32)
    .replace(/^(.{8})(.{0,4})(.{0,4})(.{0,4})(.{0,12}).*$/, (_, p1, p2, p3, p4, p5) =>
      [p1, p2, p3, p4, p5].filter(Boolean).join('-')
    );
};

// Função para normalizar o _id
export const normalizeMachineId = (str: string): string => {
  if (!str) return '';

  // 1. Remove parênteses e conteúdo dentro
  let cleaned = str.replace(/\(.*?\)/g, '');

  // 2. Pega apenas a parte antes da primeira barra /
  cleaned = cleaned.split('/')[0];

  // 3. Remove trechos que indicam lojas/códigos (ex: "Lj 01", "cod 14")
  //    Isso remove tudo que vem após "Lj" ou "cod"
  cleaned = cleaned.split(/\b(Lj|cod)\b/i)[0];

  // 4. Remove acentos
  let mainPart = cleaned.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  // 5. Substitui qualquer caractere inválido por hífen
  mainPart = mainPart.replace(/[^a-zA-Z0-9]+/g, '-');

  // 6. Remove hífens repetidos e do início/fim
  mainPart = mainPart.replace(/-+/g, '-').replace(/^-+|-+$/g, '');

  // 7. Converte para minúsculo
  return mainPart.toLowerCase();
};

// funções pgreports
const isNumericValue = (value: any): boolean => {
  if (value === null || value === undefined || value === '') return false;

  if (typeof value === 'number') return true;

  if (typeof value === 'string') {
    const normalized = value.replace(',', '.');
    return !isNaN(Number(normalized));
  }

  return false;
};

const parseToNumber = (value: any): number => {
  if (typeof value === 'number') return value;
  return Number(value.replace(',', '.'));
};

export const normalizeRowData = (data: any[]) => {
  return data.map((row) => {
    const newRow: any = {};

    Object.keys(row).forEach((key) => {
      const value = row[key];

      if (isNumericValue(value)) {
        newRow[key] = parseToNumber(value);
      } else {
        newRow[key] = value;
      }
    });

    return newRow;
  });
};

const numericComparator = (valueA: any, valueB: any) => {
  const a = valueA === null || valueA === undefined ? -Infinity : Number(valueA);
  const b = valueB === null || valueB === undefined ? -Infinity : Number(valueB);

  return a - b;
};

const numberFormatter = (params: any) => {
  const value = params.value;

  if (value === null || value === undefined || value === '') return '';

  if (typeof value === 'number') {
    return value.toLocaleString('pt-BR', { useGrouping: false });
  }

  return value;
};

export const detectNumericColumns = (data: any[], columns: any[]) => {
  if (!data || data.length === 0) return columns;

  return columns.map((col) => {
    const field = col.field;
    if (!field) return col;

    const isNumericColumn = data.every((row) => isNumericValue(row[field]));

    if (isNumericColumn) {
      return {
        ...col,
        comparator: numericComparator,
        filter: 'agNumberColumnFilter',
        valueFormatter: numberFormatter,
        type: 'numericColumn',

        cellStyle: { textAlign: 'left' },
        headerClass: 'ag-left-aligned-header'
      };
    }

    return col;
  });
};

// função para baixar o arquivo de configuração do extrator de dados
export const downloadConfigEnv = (myEmp: any, values: any, machine: any) => {
  // Monta o conteúdo do arquivo
  const content = `
########################################
# CONFIGURAÇÃO DO EXTRATOR DE DADOS
########################################
COMMAND_INTERVAL = 10 # Intervalo entre comandos em segundos


########################################
# IDENTIFICAÇÃO DO CLIENTE
########################################

# ID da Empresa no sistema
IDEMP=${myEmp.id}

# Identificação única da máquina onde o agente está rodando
# Recomenda-se usar um padrão: [ID]-[WL]-[Cliente]
ID_MAQUINA=${machine.machine_id || ''}


########################################
# API MULTITENANT
########################################

# URL base da API Multitenant
API_URL=https://api.multitenant.pgfarma.digital

# Token JWT de acesso permanente (não expira)
API_TOKEN= 
`;

  // Cria um blob do tipo text/plain
  const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });

  // Cria link temporário para download
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = 'config.env';

  // Dispara download
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Moeda pt-BR
export const formatarMoeda = (value: string): string => {
  if (!value) return '0,00';
  const minusCount = (value.match(/-/g) || []).length;
  const isNegative = minusCount % 2 !== 0;
  const cleanValue = value.replace(/\D/g, '');
  if (!cleanValue) return isNegative ? '-0,00' : '0,00';
  const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
  const result = new Intl.NumberFormat('pt-BR', options).format(
    parseFloat(cleanValue) / 100
  );
  return isNegative ? `-${result}` : result;
};


export const parseDate = (dateStr: any) => {
  if (!dateStr) return new Date(0);

  if (dateStr instanceof Date) return dateStr;

  if (typeof dateStr === 'string') {
    // Trata formato DD/MM/YYYY
    if (dateStr.includes('/')) {
      const [day, month, year] = dateStr.split('/').map(Number);
      return new Date(year, month - 1, day);
    }

    // Trata formato YYYY-MM-DD (ISO) evitando o shift de fuso horário
    if (dateStr.includes('-')) {
      const [year, month, day] = dateStr.split('T')[0].split('-').map(Number);
      return new Date(year, month - 1, day);
    }
  }

  const d = new Date(dateStr);
  return isNaN(d.getTime()) ? new Date(0) : d;
};

export const formatDate = (date: any) => {
  if (!date) return '-';

  const d = parseDate(date);

  if (d.getTime() === 0) return '-';

  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();

  return `${day}/${month}/${year}`;
};

export const compareMonth = (dateA: any, filterMonth: string) => {
  if (!filterMonth) return true;
  const d = parseDate(dateA);
  if (d.getTime() === 0) return false;

  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const monthStr = `${y}-${m}`;

  return monthStr === filterMonth;
};

export const isNegativeAccount = (dre: any) => {
  if (!dre) return false;

  const id = dre.id?.trim() || '';
  const regime = dre.regime?.trim().toUpperCase() || '';
  const conta = dre.conta?.trim().toUpperCase() || '';

  // Ambos regimes
  if (['2.1', '2.2', '3.2'].includes(id)) return true;

  // DLP (COMPETÊNCIA)
  if (regime === 'COMPETÊNCIA' && ['1.2', '1.4'].includes(id)) return true;

  // Fluxo de caixa (CAIXA)
  if ((regime === 'CAIXA' || regime === 'FLUXO DE CAIXA') && ['1.2'].includes(id)) return true;

  // Fallback verificando a string do nome da conta
  if (
    conta.includes('1.2 DESCONTO') ||
    conta.includes('1.4 CMV') ||
    conta.includes('2.1 DESPESAS') ||
    conta.includes('2.2 DESPESAS') ||
    conta.includes('3.2 DESPESAS') ||
    conta.includes('1.2 FORNECEDORES')
  ) {
    return true;
  }

  return false;
};

export const isPositiveAccount = (dre: any) => {
  if (!dre) return false;
  const id = dre.id?.trim() || '';
  if (id === '1.1') return true;
  return false;
};

export const calculateAccountValue = (dre: any, formValues: any, listInfo: any[], listDres: any[]) => {
  if (!dre || !formValues.dataCompetencia || !formValues.codigoLoja) return null;
  const id = dre.id?.trim() || '';
  const regime = dre.regime?.trim().toUpperCase() || '';
  const month = formValues.dataCompetencia.substring(0, 7);
  const loja = formValues.codigoLoja;

  const getValorById = (targetId: string, visited: Set<string> = new Set(), overrideRegime?: string): number => {
    if (visited.has(targetId)) return 0;
    visited.add(targetId);

    const targetRegime = overrideRegime || regime;
    let targetDre = listDres.find((d: any) => {
      const dId = d.id?.trim();
      return (dId === targetId || dId === targetId + '0' || dId === targetId + '00') && d.regime?.trim().toUpperCase() === targetRegime;
    });

    if (!targetDre && overrideRegime === 'FLUXO DE CAIXA') {
      targetDre = listDres.find((d: any) => {
        const dId = d.id?.trim();
        return (dId === targetId || dId === targetId + '0' || dId === targetId + '00') && d.regime?.trim().toUpperCase() === 'CAIXA';
      });
    }

    if (!targetDre) {
      targetDre = listDres.find((d: any) => {
        const dId = d.id?.trim();
        return dId === targetId || dId === targetId + '0' || dId === targetId + '00';
      });
    }

    if (!targetDre) {
      return 0;
    }

    const entries = listInfo.filter((item: any) => {
      const itemMonth = item.dataCompetencia?.substring(0, 7);
      return String(item.conta) === String(targetDre._id) && String(itemMonth) === String(month) && String(item.codigoLoja) === String(loja);
    });

    if (entries.length > 0) {
      const isCalculatedAccount = ['1.3', '1.5', '2.3', '3.3'].includes(targetId);
      if (!isCalculatedAccount) {
        return entries.reduce((acc: number, item: any) => acc + Number(item.valor || 0), 0);
      }
    }

    let calcVal = 0;
    if (regime === 'COMPETÊNCIA') {
      if (targetId === '1.3') calcVal = getValorById('1.1', visited) + getValorById('1.2', visited);
      else if (targetId === '1.5') calcVal = getValorById('1.3', visited) + getValorById('1.4', visited);
      else if (targetId === '2.3') calcVal = getValorById('1.5', visited) + getValorById('2.1', visited) + getValorById('2.2', visited);
      else if (targetId === '3.3') calcVal = getValorById('2.3', visited) + getValorById('3.1', visited) + getValorById('3.2', visited);
    } else if (regime === 'CAIXA' || regime === 'FLUXO DE CAIXA') {
      if (targetId === '1.3') calcVal = getValorById('1.1', visited, overrideRegime) + getValorById('1.2', visited, overrideRegime);
      else if (targetId === '2.3') {
        calcVal = getValorById('1.3', visited) + getValorById('2.1', visited) + getValorById('2.2', visited);
      }
      else if (targetId === '3.3') calcVal = getValorById('2.3', visited) + getValorById('3.1', visited) + getValorById('3.2', visited);
    }
    
    // Fallback: Se o recálculo der 0 (não tem filhos preenchidos) e a conta possui valor direto, usa o direto.
    if (calcVal === 0 && entries.length > 0) {
      const sumVal = entries.reduce((acc: number, item: any) => acc + Number(item.valor || 0), 0);
      if (!isNaN(sumVal) && sumVal !== 0) calcVal = sumVal;
    }

    return calcVal;
  };

  let result = null;
  if (regime === 'COMPETÊNCIA') {
    if (id === '1.3') result = getValorById('1.1') + getValorById('1.2');
    else if (id === '1.5') result = getValorById('1.3') + getValorById('1.4');
    else if (id === '2.3') result = getValorById('1.5') + getValorById('2.1') + getValorById('2.2');
    else if (id === '3.3') result = getValorById('2.3') + getValorById('3.1') + getValorById('3.2');
  } else if (regime === 'CAIXA' || regime === 'FLUXO DE CAIXA') {
    if (id === '1.3') result = getValorById('1.1') + getValorById('1.2');
    else if (id === '2.3') {
      result = getValorById('1.3') + getValorById('2.1') + getValorById('2.2');
    }
    else if (id === '3.3') result = getValorById('2.3') + getValorById('3.1') + getValorById('3.2');
  }

  // Fallback final: se o resultado do item raiz for 0, usa o valor original do form ou banco
  if (result === 0) {
    let originalValor = dre?.valor !== undefined ? Number(dre.valor) : null;
    if (originalValor === null || isNaN(originalValor)) {
      const entry = listInfo.find(
        (item) => item.dreId === dre?._id || item.conta === dre?._id
      );
      if (entry && entry.valor !== undefined) {
        originalValor = Number(entry.valor);
      }
    }
    if (originalValor !== null && !isNaN(originalValor) && originalValor !== 0) {
      result = originalValor;
    }
  }

  return result;
};